import axiosInstance from "src/helpers/axiosInstance";


export const FacilityDropdown = (client) => onResponse => {

    try {
        axiosInstance.post(`/users/facilities/get-facility-dropdown`,{client:client})
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


